import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const surveyLocaleModule: LocaleModule = {
  name: "survey",
  messages: { en: en, it: it },
};
